import { theme } from "../styles/theme";

function TablaRegistros({ data, onEdit, onDelete, soloLectura = false }) {
  return (
    <div style={styles.wrapper}>
      <table
        style={{
          width: "100%",
          minWidth: "980px",
          background: theme.colors.panelBg,
          color: theme.colors.text,
          borderCollapse: "separate",
          borderSpacing: 0
        }}
      >
        <thead>
          <tr style={{ background: theme.colors.tableHeader }}>
            <th style={styles.headCell}>Maestria</th>
            <th style={styles.headCell}>Cohorte</th>
            <th style={styles.headCell}>Estudiante</th>
            <th style={styles.headCellTema}>Tema</th>
            <th style={styles.headCell}>Tutor</th>
            <th style={styles.headCell}>Revisor</th>
            {!soloLectura && <th style={styles.headCell}>Acciones</th>}
          </tr>
        </thead>

        <tbody>
          {data.map((item, i) => (
            <tr key={i} style={{ background: i % 2 === 0 ? "#ffffff" : "#f8fafc" }}>
              <td style={styles.cell}>{item.maestria || "-"}</td>
              <td style={styles.cell}>{item.cohorte || "-"}</td>
              <td style={styles.cell}>{item.estudiante || "-"}</td>
              <td style={styles.topicCell}>{item.tema || "-"}</td>
              <td style={styles.cell}>{item.director || "-"}</td>
              <td style={styles.cell}>{item.evaluador || "-"}</td>
              {!soloLectura && (
                <td style={styles.actionCell}>
                  <div style={styles.actionButtons}>
                    <button
                      type="button"
                      onClick={() => onEdit?.(item, i)}
                      style={styles.editButton}
                    >
                      Editar
                    </button>
                    <button
                      type="button"
                      onClick={() => onDelete?.(item, i)}
                      style={styles.deleteButton}
                    >
                      Eliminar
                    </button>
                  </div>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

const styles = {
  wrapper: {
    width: "100%",
    maxHeight: "calc(100vh - 190px)",
    overflowX: "auto",
    overflowY: "auto",
    borderRadius: "14px",
    border: `1px solid ${theme.colors.border}`,
    boxShadow: "0 12px 30px rgba(18, 38, 63, 0.08)",
    background: theme.colors.panelBg,
    position: "relative"
  },
  headCell: {
    padding: "14px 16px",
    textAlign: "left",
    color: theme.colors.text,
    position: "sticky",
    top: 0,
    zIndex: 3,
    background: theme.colors.tableHeader,
    boxShadow: `0 1px 0 ${theme.colors.border}`
  },
  headCellTema: {
    padding: "14px 16px",
    textAlign: "left",
    color: theme.colors.text,
    minWidth: "280px",
    position: "sticky",
    top: 0,
    zIndex: 3,
    background: theme.colors.tableHeader,
    boxShadow: `0 1px 0 ${theme.colors.border}`
  },
  cell: {
    padding: "14px 16px",
    borderTop: `1px solid ${theme.colors.border}`,
    color: theme.colors.subtext
  },
  topicCell: {
    padding: "14px 16px",
    borderTop: `1px solid ${theme.colors.border}`,
    color: theme.colors.subtext,
    minWidth: "280px",
    lineHeight: 1.45
  },
  actionCell: {
    padding: "14px 16px",
    borderTop: `1px solid ${theme.colors.border}`,
    whiteSpace: "nowrap"
  },
  actionButtons: {
    display: "flex",
    alignItems: "center",
    gap: "8px"
  },
  editButton: {
    background: theme.colors.primarySoft,
    color: theme.colors.primary,
    border: `1px solid ${theme.colors.border}`,
    borderRadius: "10px",
    padding: "8px 12px",
    cursor: "pointer",
    fontWeight: 700
  },
  deleteButton: {
    background: "#fde8e8",
    color: "#b42318",
    border: "1px solid #f5c2c7",
    borderRadius: "10px",
    padding: "8px 12px",
    cursor: "pointer",
    fontWeight: 700
  }
};

export default TablaRegistros;
